import { useState } from "react";
import { useForm } from "react-hook-form";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../../contexts/AuthContext";
import images from "../../components/images";

function ComfirmPassword({ onSubmitHandler, loading }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    mode: "onChange", // 👈 validate while typing
  });

  // watch password + confirmPassword
  const password = watch("password");
  const confirmPassword = watch("confirmPassword");

  // Only enable submit if both match and not empty
  const isMatch = password && confirmPassword && password === confirmPassword;

  const onSubmit = (data) => {
    if (isMatch) {
      onSubmitHandler(data);
    }
  };

  return (
    <>
      {/* Top Bar */}
      <div className="fixed top-0 left-0 w-full bg-brandBlue border-b-8 border-brandYellow py-5 z-10"></div>

      <div className="min-h-screen flex items-center justify-center bg-gray-50 ">
        <div className="p-[80px] max-w-[640px] w-full space-y-8 bg-white rounded-[20px] shadow-[0px_0px_20px_0px_#0000001A]">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img
              src={images.logo}
              alt="Future Forward Logo"
              className="w-100"
            />
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            {/* New Password */}
            <div className="relative">
              <label
                htmlFor="password"
                className="block text-[#717576] font-opensans text-[15px] font-normal"
              >
                New Password
              </label>
              <div className="mt-1 relative">
                <input
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 6,
                      message: "Password must be at least 6 characters",
                    },
                  })}
                  type={showPassword ? "text" : "password"}
                  className="input pr-10 mt-1 rounded-[10px] py-[17px] px-4 
                   bg-[#7175760F] focus:outline-none focus:ring-2 
                   focus:ring-[#7175760F] text-[15px] placeholder:text-[15px] w-full"
                  placeholder="Enter New Password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <EyeSlashIcon className="h-5 w-5 text-gray-400" />
                  ) : (
                    <EyeIcon className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
              {errors.password && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.password.message}
                </p>
              )}
            </div>

            {/* Confirm Password */}
            <div className="relative">
              <label
                htmlFor="confirmPassword"
                className="block text-[#717576] font-opensans text-[15px] font-normal"
              >
                Confirm Password
              </label>
              <div className="mt-1 relative">
                <input
                  {...register("confirmPassword", {
                    required: "Confirm Password is required",
                    validate: (value) =>
                      value === password || "Your password is not match",
                  })}
                  type={showConfirmPassword ? "text" : "password"}
                  className="input pr-10 mt-1 rounded-[10px] py-[17px] px-4 
                   bg-[#7175760F] focus:outline-none focus:ring-2 
                   focus:ring-[#7175760F] text-[15px] placeholder:text-[15px] w-full"
                  placeholder="Re-enter Password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <EyeSlashIcon className="h-5 w-5 text-gray-400" />
                  ) : (
                    <EyeIcon className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
              {errors.confirmPassword && (
                <p className="mt-1 text-sm text-red-600">
                  {errors.confirmPassword.message}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div>
              <button
                type="submit"
                disabled={loading || !isMatch}
                className={`btn-primary w-full py-[17px] px-4 text-base rounded-[10px] transition-colors duration-300
                  ${
                    isMatch
                      ? "bg-brandBlue cursor-pointer"
                      : "bg-gray-400 cursor-not-allowed"
                  }`}
              >
                {loading ? "Saving..." : "Save Password"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 w-full bg-brandBlue border-t-8 border-brandYellow py-5 z-10"></div>
    </>
  );
}

export default ComfirmPassword;
